<script setup>
import { reactive, toRef } from "vue";
import moment from 'moment';
import {bytesToMegabytes} from '@/Mixins/filesizeCalculator.js'
import UploadListActions from '@/Components/Uploads/UploadListActions.vue'
import UploadListNameCell from '@/Components/Uploads/UploadListNameCell.vue'

const props = defineProps({
    files: {
        type: Array,
        default: () => [],
        required: false,
    },
});

const emit = defineEmits(['file-deleted'])

const rowData = toRef(props, 'files')

// helper function to convert date

const dateFormatted = (date) => moment(date).format("DD MMM YYYY")

const defaultColDef = {
    sortable: true,
    filter: true,
    flex: 1,
    dataTestid: "column",
    resizable: true,
    show: true,
};

const columnDefs = reactive({
    value: [
        {
            headerName: "Name",
            field: "name",
            flex: 3,
			cellRenderer: UploadListNameCell,
        },
        {
            field: "size",
            flex: 2,
            valueFormatter: (params) =>
                bytesToMegabytes(params.value),
        },
        {
            headerName: "Uploaded",
            field: "created_at",
            flex: 3,
			valueFormatter: (params) => dateFormatted(params.value)
        },
		{ 
			headerName: "Actions",
			flex: 4,
			field: 'id',
			cellRenderer: UploadListActions,
			cellRendererParams: {
				fileDeleted: function(id) {
					emit('file-deleted', id)
				}
			}
		},
    ],
});

</script>

<template>

    <div v-if="props.files.length > 0" class="flex flex-col h-full grow" >
		
       <ag-grid-vue 
            class="ag-theme-alpine"
            domLayout="autoHeight"
            :rowHeight="48"
            :columnDefs="columnDefs.value"
            :rowData="rowData"
            :defaultColDef="defaultColDef"
            rowSelection="none"
            animateRows="true"
            :pagination="true"
            :paginationPageSize="10"
        >
        </ag-grid-vue>
 
    </div>
</template>

